import { cn } from '@/utils/cn';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
};

export function Disclaimer({ children, className }: Props) {
  return (
    <div
      className={cn(
        'border-primary flex flex-col gap-4 border-l-4 bg-white/10 p-6 text-white/80',
        className,
      )}
    >
      {children}
    </div>
  );
}
